export class Clase {
    n?:string;
    idclase?:string;
    nombre?:string;
    fechareg?:any;
    fechamod?:any;
    usuario_id?:number;
    activo?:boolean;
    constructor(){}
}
